import { apiSlice } from '@/redux/api-slice'
import type { UserRights } from './types'

const userRightsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getUserRights: build.query<UserRights, void>({
      query: () => ({
        url: 'Authorization/',
      }),
    }),
  }),
})

export const { useGetUserRightsQuery, useLazyGetUserRightsQuery } =
  userRightsApi
